const apiUrl = process.env.REACT_APP_API_URL;

export const getFolios = async (page = 1, pageSize = 10, onlyActives) => {
    const token = sessionStorage.getItem('token');
    const qs = new URLSearchParams({
        page: String(page),
        pageSize: String(pageSize),
        ...(onlyActives !== undefined ? { onlyActives: onlyActives ? '1' : '0' } : {})
    });

    const url = `${apiUrl}/api/configs/getFolios?${qs.toString()}`;

    try {
        const res = await fetch(url, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        });
        if (!res.ok) {
            return { items: [], total: 0, page, pageSize, totalPages: 0 };
        }
        // ← devolvemos el objeto paginado tal cual
        return await res.json();
    } catch {
        return { items: [], total: 0, page, pageSize, totalPages: 0 };
    }
};

export const getFoliosById = async (id) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/configs/getFoliosById/${id}`;
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    };

    try {
        const response = await fetch(url, requestOptions);
        return await response.json();
    } catch (error) {
        return {}
    }
};

export async function addFoliosRange(start, end, prefix = 'Nn-', isActive = true) {
    const token = sessionStorage.getItem('token');
    const res = await fetch(`${apiUrl}/api/configs/bulk`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ start, end, prefix, isActive })
    });
    return await res.json();
}

export const addFolios = async (name) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/configs/addFolios`;
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
            name
        })
    };

    try {
        const response = await fetch(url, requestOptions);
        return await response.json();
    } catch (error) {
        return { result: false }
    }
};

export const updateFolios = async (id, name, isActive) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/configs/updateFolios`;
    const requestOptions = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
            id, name, isActive
        })
    };

    try {
        const response = await fetch(url, requestOptions);
        return await response.json();
    } catch (error) {
        return {}
    }
};

export const getFoliosByQuery = async (q = '', options = {}) => {
    const {
        itemId,
        onlyActives,
        onlyUnsold,
        onlyNotWasted,
        page = 1,
        pageSize = 50,
    } = options;

    const token = sessionStorage.getItem('token');

    const qs = new URLSearchParams({
        q,
        page: String(page),
        pageSize: String(pageSize),
    });

    if (onlyActives !== undefined) {
        qs.append('onlyActives', String(onlyActives));        // "true"/"false"
    }
    if (itemId) {
        qs.append('itemId', String(itemId));
    }
    if (onlyUnsold !== undefined) {
        qs.append('onlyUnsold', String(onlyUnsold));          // "true"/"false"
    }
    if (onlyNotWasted !== undefined) {
        qs.append('onlyNotWasted', String(onlyNotWasted));    // "true"/"false"
    }

    const url = `${apiUrl}/api/configs/getFoliosByQuery?${qs.toString()}`;

    const res = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    });

    if (!res.ok) return { items: [] };
    return await res.json();
};